<script lang="ts">
    import {onMount} from "svelte";

    export let value;
    export let map = null;


    onMount(() => {
    });


</script>

<span class="display-value-view">
    {#if value != null}
        {#if map != null}
            {#if value in map}
                { map[value] }
            {:else}
                <span class="none" data-value={value} title="不明な値です">?</span>
            {/if}
        {:else}
            { value }
        {/if}
    {:else}
        <span class="none">設定なし</span>
    {/if}

</span>

<style lang="scss">
    .display-value-view {
        display: inline-block;
        height: 1em;

        .none {
            font-size: 0.5em;
            opacity: 0.5;
            user-select: none;
        }

    }

</style>